export const homeRoutes = {
	children: [{
		component: () => import(`@/view/Home.vue`),
		name: `Home`,
		path: ``
	}, {
		component: () => import(`@/view/Join.vue`),
		name: `Join`,
		path: `join`
	}],
	component: () => import(`@/view/OneSidebar.vue`),
	path: `/`
};
